import React, { FC } from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { WorkExperienceData } from '../WorkExperience';
import { calculateTotalDuration, formatDateRange, getEmploymentTypeCopy } from '../utils/workExperienceUtils';

export interface ExperienceDetailsProps {
    experience: WorkExperienceData;
    inTimeline?: boolean;
    isMultipleExperiences?: boolean;
    companyExperiences?: WorkExperienceData[];
}

export const ExperienceDetails: FC<ExperienceDetailsProps> = ({
    experience,
    inTimeline = false,
    isMultipleExperiences = false,
    companyExperiences = [],
}) => {
    const isCompanyHeader = isMultipleExperiences && !inTimeline;
    const totalDuration = calculateTotalDuration(isCompanyHeader ? companyExperiences : [experience]);
    const employmentType = getEmploymentTypeCopy(experience.employmentType);
    const dateRange = formatDateRange(experience.startDate, experience.endDate);
    const isTimelineRole = isMultipleExperiences && inTimeline;
    const isSingleExperience = !isMultipleExperiences;

    return (
        <Container display="flex" direction="column">
            <Text fontWeight="semibold" style={!isCompanyHeader ? { textTransform: 'capitalize' } : {}}>
                {isCompanyHeader ? experience.company?.name : experience.title}
            </Text>

            {isCompanyHeader && (
                <Text size="b_sm">
                    {employmentType && `${employmentType} • `}
                    {totalDuration}
                </Text>
            )}

            {isTimelineRole && (
                <Text size="b_sm" color="bodySecondary">
                    {dateRange} • {totalDuration}
                </Text>
            )}

            {isSingleExperience && (
                <>
                    <Text size="b_sm" color="bodySecondary">
                        {experience.company?.name}
                        {employmentType && ` • ${employmentType}`}
                    </Text>
                    <Text size="b_sm" color="bodySecondary">
                        {dateRange} • {totalDuration}
                    </Text>
                </>
            )}

            {!isCompanyHeader && experience.description && (
                <Text size="b_sm" marginTop="2" whiteSpace="preWrap" overflowWrap="breakWord">
                    {experience.description}
                </Text>
            )}
        </Container>
    );
};
